import { gql } from '@apollo/client';

const schema = {
  update: {
    name: 'updateUnit',
    serviceName: 'unitadmin',
    query: gql`
      mutation updateUnit($default_lab_items: [DefaultLabInput]) {
        updateUnit(default_lab_items: $default_lab_items) {
          messages
        }
      }
    `,
  },
};

export default schema;
